<div class="col-md-12 border d-flex flex-column align-items-center">
  <label class="form-label fw-bold px-3 mt-2 text-center w-100">Área de Revisión</label>

  <div class="p-3" style="width: 50%;">
    <div class="d-flex justify-content-center gap-2">
      <!-- Botón de Aceptar Informe -->
      <button class="btn btn-success btn-sm" (click)="approveReportResponse()"><i class="fa fa-check"></i> Aprobar
        Informe</button>
      <!-- Botón de Rechazar revisión -->
      <button class="btn btn-danger btn-sm" (click)="rejectReportResponse()"><i class="fa fa-x"></i> Rechazar
        Informe</button>
      <!-- Botón de Rechazar y mandar a corregir -->
      <button class="btn btn-warning btn-sm" (click)="correctionReportResponse()"><i class="fa fa-arrow-left"></i>
        Enviar a Corregir</button>
      <!--Botón de Pagar Informe Manualmente-->
       <button class="btn btn-primary btn-sm"><i class="fa fa-money"></i>
        Marcar como Pagado</button>
    </div>
  </div>
</div>